var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.89543 0.895431 1 2 1H3C3.55228 1 4 1.44772 4 2C4 2.55228 3.55228 3 3 3L2 3V13H12V3H11C10.4477 3 10 2.55228 10 2C10 1.44772 10.4477 1 11 1H12C13.1046 1 14 1.89543 14 3V13C14 14.1046 13.1046 15 12 15H2C0.89543 15 0 14.1046 0 13V3Z",
    fill: "#73A9AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H4L5 12H9L10 10H13V14H1V10Z",
    fill: "#73A9AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29289 5.29289C4.68342 4.90237 5.31658 4.90237 5.70711 5.29289L6 5.58579V1C6 0.447716 6.44771 0 7 0C7.55228 0 8 0.447715 8 1L8 5.58579L8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289C10.0976 5.68342 10.0976 6.31658 9.70711 6.70711L7.70711 8.70711C7.51957 8.89464 7.26522 9 7 9C6.73478 9 6.48043 8.89464 6.29289 8.70711L4.29289 6.70711C3.90237 6.31658 3.90237 5.68342 4.29289 5.29289Z",
    fill: "#73A9AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsupload);
export default __webpack_public_path__ + "static/media/documentsupload.9f572c37a1bdca131cd60487e46b2d13.svg";
export { ForwardRef as ReactComponent };